import type { PropsWithChildren, ReactNode } from 'react';
import styles from './BorderedBox.module.scss';

interface Props extends PropsWithChildren {
	legend?: string;
}

export function BorderedBox(props: Props): ReactNode {
	const label = props.legend;
	let legend = null;
	if (label) {
		legend = <legend>{label}</legend>;
	}

	// TODO: fieldset can't contain tables and was causing problems
	return (
		<div className={styles['main']}>
			{legend}
			{props.children}
		</div>
	);
}
